import { motion } from "framer-motion";
import { MessageCircle, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Arjun S.",
    handle: "Verified member",
    market: "Member result",
    image: "/WhatsApp%20Image%202026-09-23%20at%203.14.42%20PM.jpeg",
    message: "The biggest difference for me is having a plan before the market moves. I am much more patient with my entries now.",
  },
  {
    name: "Priya K.",
    handle: "Verified member",
    market: "Member result",
    image: "/WhatsApp%20Image%202026-09-23%20at%203.15.16%20PM.jpeg",
    message: "The explanations make the setups much easier to follow. I have stopped chasing every candle and started waiting for confirmation.",
  },
  {
    name: "Vikram R.",
    handle: "Verified member",
    market: "Member result",
    image: "/WhatsApp%20Image%202026-09-23%20at%203.17.53%20PM.jpeg",
    message: "I joined to bring more discipline to my trading. The daily structure keeps me focused on risk instead of reacting emotionally.",
  },
  {
    name: "Rahul M.",
    handle: "Verified member",
    market: "Gold room",
    image: "/WhatsApp%20Image%202026-09-23%20at%203.39.57%20PM.jpeg",
    message: "The room helped me understand why waiting for the right level matters. I am finally trading with more patience and less guesswork.",
  },
  {
    name: "Neha P.",
    handle: "Verified member",
    market: "Gold room",
    image: "/WhatsApp%20Image%202026-09-23%20at%203.42.05%20PM%20(1).jpeg",
    message: "The clear levels and updates made this setup much easier to manage. I appreciate how focused the guidance stays.",
  },
  {
    name: "Amit D.",
    handle: "Verified member",
    market: "Gold room",
    image: "/WhatsApp%20Image%202026-09-23%20at%203.42.05%20PM%20(2).jpeg",
    message: "I like that the calls come with a plan instead of noise. It has made my trading routine feel much more structured.",
  },
  {
    name: "Sana K.",
    handle: "Verified member",
    market: "Gold room",
    image: "/WhatsApp%20Image%202026-09-23%20at%203.42.05%20PM.jpeg",
    message: "The explanations around entries and targets are simple to follow. That clarity has helped me stay consistent with my process.",
  },
  {
    name: "Rohan T.",
    handle: "Verified member",
    market: "Gold room",
    image: "/WhatsApp%20Image%202026-09-23%20at%203.42.06%20PM.jpeg",
    message: "Seeing the plan play out gave me more confidence in following my rules. The focus on discipline is what I value most.",
  },
];

const Testimonials = () => (
  <section id="testimonials" className="relative overflow-hidden py-28 sm:py-36" data-testid="testimonials-section">
    <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-black/10" />

    <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-12 flex flex-col justify-between gap-6 sm:flex-row sm:items-end"
      >
        <div className="max-w-2xl">
          <p className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-slate-500">(05) — Voices</p>
          <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-[#0a0a0a] sm:text-5xl">
            The room speaks <span className="font-accent text-grad-aurora">for itself.</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
            Real notes from people building a calmer, more deliberate trading routine.
          </p>
        </div>
        <div className="flex items-center gap-2 font-mono2 text-[10px] uppercase tracking-[0.25em] text-slate-400">
          <MessageCircle className="h-4 w-4" />
          Member appreciation
        </div>
      </motion.div>

      <div
        className="relative left-1/2 w-screen -translate-x-1/2 overflow-hidden pb-5"
        data-testid="testimonials-slider"
      >
        <div className="marquee-track flex w-max gap-5 px-[5vw] hover:[animation-play-state:paused] focus-within:[animation-play-state:paused]">
          {[...TESTIMONIALS, ...TESTIMONIALS].map((testimonial, index) => (
            <article
              key={`${testimonial.handle}-${index}`}
              className="w-[85vw] shrink-0 sm:w-[42vw] lg:w-[30vw]"
              data-testid={`testimonial-card-${index % TESTIMONIALS.length}`}
            >
            <div className="glass lift flex min-h-[340px] flex-col overflow-hidden rounded-3xl">
            {testimonial.image ? (
              <div className="relative aspect-video overflow-hidden border-b border-black/10 bg-black/5">
                <img src={testimonial.image} alt={`Trading result shared by ${testimonial.name}`} className="h-full w-full object-contain" />
              </div>
            ) : (
              <div className="relative flex min-h-[190px] flex-1 items-center justify-center overflow-hidden border-b border-black/10 bg-black/[0.03] p-8">
                <Quote className="absolute right-6 top-6 h-16 w-16 text-black/5" strokeWidth={1} />
                <p className="relative font-sub text-lg leading-relaxed text-slate-700">“{testimonial.message}”</p>
              </div>
            )}

            <div className="p-5">
              {testimonial.image && (
                <p className="mb-5 font-sub text-sm leading-relaxed text-slate-700">“{testimonial.message}”</p>
              )}
              <div className="flex items-end justify-between gap-4">
                <div>
                  <p className="font-sub text-sm font-semibold text-[#0a0a0a]">{testimonial.name}</p>
                  <p className="mt-1 font-mono2 text-[10px] uppercase tracking-widest text-slate-400">{testimonial.handle}</p>
                </div>
                <span className="rounded-full border border-black/10 bg-black/5 px-3 py-1 font-mono2 text-[9px] uppercase tracking-widest text-slate-600">
                  {testimonial.market}
                </span>
              </div>
            </div>
            </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Testimonials;
